import { DetailTurnModalProps } from "./types";
import { GetOneAppointmentResponseService } from "../../../services/TurnServices/Turns.type";
import { Modal } from "../../../components/others/Modal";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import StyledWrapper from "./style";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import LavorisService from "../../../services/LavorisService";
import { useFetchOne } from "../../../hooks";
import { TagField } from "../../../components/others/TagField";
import {
  MoldeDetails,
  ExamDetails,
  PracticesList,
} from "../AppointmentMetadata";

const DetailTurnWithDateParticular: React.FC<DetailTurnModalProps> = ({
  closeModal,
  ...modalProps
}) => {
  const rowData = useFetchOne<GetOneAppointmentResponseService>("appointments");

  const LavorisInstance = LavorisService.getInstance();
  const fileArray = rowData?.files;
  let fileId = ""; // Declarar la variable fileId fuera del bloque if

  if (Array.isArray(fileArray) && fileArray.length > 0) {
    const firstFile = fileArray[0];
    if (firstFile && typeof firstFile === "object" && "id" in firstFile) {
      fileId = firstFile.id; // Asignar el valor de fileId dentro del bloque if
      //console.log(fileId);
    } else {
      console.log("No se encontró el ID del archivo");
    }
  } else {
    console.log("No hay archivos disponibles");
  }

  if (!rowData)
    return (
      <Modal
        {...modalProps}
        titleStyle="text-2xl text-red-500 font-bold my-4"
        modalContainerStyle="max-w-lg"
      >
        <h1 className="w-full flex justify-center text-red-500 font-bolder animate-pulse">
          {" "}
          Cargando...{" "}
        </h1>
      </Modal>
    );
  let downloadButton = null;
  if (fileArray && fileArray.length > 0) {
    downloadButton = (
      <button
        onClick={async () => {
          await LavorisInstance.FilesService.getReportAWSFileById(fileId);
        }}
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.87)",
          color: "white",
          fontWeight: "bold",
          padding: "10px",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Descargar
        <FileDownloadOutlinedIcon style={{ marginLeft: "6px" }} />
      </button>
    );
  } else {
    downloadButton = <p>No hay archivos adjuntos para descargar</p>;
  }

  return (
    <Modal
      {...modalProps}
      titleStyle="text-2xl text-red-500 font-bold my-4"
      modalContainerStyle="max-w-lg"
    >
      <div className="mb-4 max-w-lg">
        <div className="flex gap-10 items-center bg-[#F8F7F7] rounded-lg p-4">
          <div>
            <p>
              <span className="font-semibold text-lg">
                {rowData?.patient.name || "N/A"}
              </span>
            </p>
            <p>
              <StyledWrapper.ListItemCard>DNI:</StyledWrapper.ListItemCard>
              {rowData?.patient.DNI || "N/A"}
            </p>
            <p>
              <StyledWrapper.ListItemCard>
                Fecha de Nacimiento:
              </StyledWrapper.ListItemCard>
              {rowData?.patient.birthDate || "N/A"}
            </p>
            <p>
              <StyledWrapper.ListItemCard>Puesto:</StyledWrapper.ListItemCard>
              {"Cliente Particular"}
            </p>
          </div>
        </div>

        {rowData?.metadata.molde ? (
          <div className="flex flex-col max-w-lg">
            <StyledWrapper.ListItem>Molde:</StyledWrapper.ListItem>
            <div className="flex flex-wrap mb-3">
              <TagField className="bg-gray-300 font-bold">
                {rowData.metadata.molde.name || "No corresponde"}
              </TagField>
            </div>
            <MoldeDetails molde={rowData?.metadata.molde} />
          </div>
        ) : null}

        {rowData?.metadata.exam ? (
          <div className="flex flex-col max-w-lg">
            <StyledWrapper.ListItem>Examen:</StyledWrapper.ListItem>
            <div className="flex flex-wrap mb-3">
              <TagField className="bg-gray-300 font-bold">
                {rowData.metadata.exam.name}
              </TagField>
            </div>
            <ExamDetails exam={rowData.metadata.exam} />
          </div>
        ) : null}

        {rowData?.metadata.practices ? (
          <div className="flex flex-col max-w-lg mb-3">
            <StyledWrapper.ListItem>Prácticas:</StyledWrapper.ListItem>
            <PracticesList practices={rowData.metadata.practices} />
          </div>
        ) : null}

        <hr className="my-2" />
        <StyledWrapper.ListItem>
          Fecha y Hora:{" "}
          <span className="font-normal">
            {rowData?.date && rowData?.startTime
              ? `${rowData?.date} - ${rowData?.startTime}hs.`
              : "No corresponde"}
          </span>
        </StyledWrapper.ListItem>
        <hr className="my-2" />
        <StyledWrapper.ListItem>
          Estado: <span className="font-normal">{rowData?.status}</span>
        </StyledWrapper.ListItem>
        <hr className="my-2" />
        <StyledWrapper.ListItem>Comentarios:</StyledWrapper.ListItem>
        <p>{rowData?.observations || "Sin comentarios"}</p>
        <hr className="my-2" />
        <StyledWrapper.ListItem>Adjunto:</StyledWrapper.ListItem>
        {downloadButton}
      </div>
    </Modal>
  );
};

export default DetailTurnWithDateParticular;
